<template>
    <div class="container">
    <div style="background-color: white; padding: 20px;">
      <h2 style="color: black;">Is this how you are getting your trading ideas? Word of mouth is great but always do your own research!</h2>
      <div style="background-color: white; padding: 20px; border-radius: 10px;">
    
    
    <section>
      <p>
      Stock Symbol	Company	Price
    MMM	3M	92.81
    AOS	A. O. Smith	72.82
    ABT	Abbott	93.97
    ABBV	AbbVie	138.59
    ACN	Accenture	319.69
    ADM	ADM	72.5
    ADBE	Adobe Inc.	597.22
    ADP	ADP	228.49
    AES	AES Corporation	15.7
    AFL	Aflac	81.48
    A	Agilent Technologies	108.47
    ABNB	Airbnb	118.15
    APD	Air Products and Chemicals	265.46
    AKAM	Akamai	110.77
    ALK	Alaska Air Group	34.26
    ALB	Albemarle Corporation	116.98
    ARE	Alexandria Real Estate Equities	95.66
    ALGN	Align Technology	192.13
    ALLE	Allegion	103.49
    LNT	Alliant Energy	48.57
    ALL	Allstate	130.32
    GOOGL	Alphabet Inc. (Class A)	132.59
    GOOG	Alphabet Inc. (Class C)	134.06
    MO	Altria	40.02
    AMZN	Amazon	143.56
    AMCR	Amcor	9.07
    AMD	AMD	118.59
    AEE	Ameren	76.27
    AAL	American Airlines Group	11.8
    AEP	American Electric Power	77.7
    AXP	American Express	154.38
    AIG	American International Group	63.82
    AMT	American Tower	183.79
    AWK	American Water Works	123.5
    AMP	Ameriprise Financial	336.36
    AME	Ametek	150.8
    AMGN	Amgen	267.31
    APH	Amphenol	86.61
    ADI	Analog Devices	172.32
    ANSS	Ansys	291.5
    AON	Aon	334.04
    APA	APA Corporation	36.92
    AAPL	Apple Inc.	186.4
    AMAT	Applied Materials	150.68
    APTV	Aptiv	75.93
    ACGL	Arch Capital Group	85.95
    ANET	Arista Networks	206.84
    AJG	Arthur J. Gallagher & Co.	248.27
    AIZ	Assurant	163.06
    T	AT&T	15.64
    ATO	Atmos Energy	111.41
    ADSK	Autodesk	210.58
    AZO	AutoZone	2702.34
    AVB	AvalonBay Communities	168.2
    AVY	Avery Dennison	180.09
    AXON	Axon Enterprise	217.94
    BKR	Baker Hughes	34.34
    BALL	Ball Corporation	48.81
    BAC	Bank of America	27.68
    BBWI	Bath & Body Works, Inc.	31.04
    BAX	Baxter International	32.82
    BDX	Becton Dickinson	234.65
    WRB	Berkley	68.15
    BRK.B	Berkshire Hathaway	350.56
    BBY	Best Buy	64.12
    BIO	Bio-Rad	304.04
    TECH	Bio-Techne	57.49
    BIIB	Biogen	224.79
    BLK	BlackRock	665
    BX	Blackstone	98.64
    BK	BNY Mellon	45.66
    BA	Boeing	196.65
    BKNG	Booking Holdings	3074.23
    BWA	BorgWarner	32.37
    BXP	Boston Properties	52.44
    BSX	Boston Scientific	51.56
    BMY	Bristol Myers Squibb	50.61
    AVGO	Broadcom Inc.	957.52
    BR	Broadridge Financial Solutions	177.12
    BRO	Brown & Brown	72.85
    BF.B	Brown–Forman	57.02
    BG	Bunge Limited	104.53
    CHRW	C.H. Robinson	79.96
    CDNS	Cadence Design Systems	261.56
    CZR	Caesars Entertainment	43.3
    CPT	Camden Property Trust	88.44
    CPB	Campbell Soup Company	40.42
    COF	Capital One	104.58
    CAH	Cardinal Health	104.12
    KMX	CarMax	63.37
    CCL	Carnival	12.76
    CARR	Carrier Global	51.5
    CTLT	Catalent	33.55
    CAT	Caterpillar Inc.	239.68
    CBOE	Cboe Global Markets	174.97
    CBRE	CBRE Group	73.49
    CDW	CDW	211.67
    CE	Celanese	118.51
    COR	Cencora	197.57
    CNC	Centene Corporation	71.87
    CNP	CenterPoint Energy	27.12
    CDAY	Ceridian	65.45
    CF	CF Industries	79.53
    CRL	Charles River Laboratories	171.99
    SCHW	Charles Schwab Corporation	54.41
    CHTR	Charter Communications	409.81
    CVX	Chevron Corporation	142.95
    CMG	Chipotle Mexican Grill	2120.58
    CB	Chubb Limited	222.44
    CHD	Church & Dwight	89.72
    CI	Cigna	293.21
    CINF	Cincinnati Financial	99.73
    CTAS	Cintas	533.48
    CSCO	Cisco	52.59
    C	Citigroup	42.08
    CFG	Citizens Financial Group	25.17
    CLX	Clorox	133.46
    CME	CME Group	217.11
    CMS	CMS Energy	55.6
    KO	Coca-Cola Company (The)	56.72
    CTSH	Cognizant	65.95
    CL	Colgate-Palmolive	75.43
    CMCSA	Comcast	41.91
    CMA	Comerica	41.35
    CAG	Conagra Brands	27.81
    COP	ConocoPhillips	115.61
    ED	Consolidated Edison	89.35
    STZ	Constellation Brands	239.32
    CEG	Constellation Energy	121.77
    COO	CooperCompanies	329.28
    CPRT	Copart	48.73
    GLW	Corning Inc.	27.68
    CTVA	Corteva	43.55
    CSGP	CoStar Group	79.65
    COST	Costco	577.12
    CTRA	Coterra	26.97
    CCI	Crown Castle	95.64
    CSX	CSX	30.7
    CMI	Cummins	219.02
    CVS	CVS Health	67.68
    DHI	D.R. Horton	122.7
    DHR	Danaher Corporation	197
    DRI	Darden Restaurants	150.1
    DVA	DaVita Inc.	82.99
    DE	John Deere	373.99
    DAL	Delta Air Lines	34.06
    XRAY	Dentsply Sirona	28.39
    DVN	Devon Energy	45.62
    DXCM	Dexcom	94.05
    FANG	Diamondback Energy	157.71
    DLR	Digital Realty	128.75
    DFS	Discover Financial	83.51
    DIS	Disney	88.27
    DG	Dollar General	117.94
    DLTR	Dollar Tree	114.08
    D	Dominion Energy	44.96
    DPZ	Domino's	378.51
    DOV	Dover Corporation	131.63
    DOW	Dow Inc.	49.48
    DTE	DTE Energy	98.57
    DUK	Duke Energy	88.27
    DD	DuPont	68.74
    EMN	Eastman Chemical Company	77.13
    ETN	Eaton Corporation	221.82
    EBAY	eBay	39.85
    ECL	Ecolab	177.9
    EIX	Edison International	63.72
    EW	Edwards Lifesciences	64.21
    EA	Electronic Arts	132.78
    ELV	Elevance Health	458.25
    LLY	Eli Lilly and Company	597.71
    EMR	Emerson Electric	86.5
    ENPH	Enphase	77.98
    ETR	Entergy	96.61
    EOG	EOG Resources	122.7
    EPAM	EPAM Systems	235.36
    EQT	EQT	39.13
    EFX	Equifax	184.91
    EQIX	Equinix	767.27
    EQR	Equity Residential	54.54
    ESS	Essex Property Trust	210.65
    EL	Estée Lauder Companies (The)	114.75
    ETSY	Etsy	63.24
    EG	Everest Re	384.68
    EVRG	Evergy	49.41
    ES	Eversource	53.8
    EXC	Exelon	39.43
    EXPE	Expedia Group	118.68
    EXPD	Expeditors International	115.35
    EXR	Extra Space Storage	119.11
    XOM	ExxonMobil	103.75
    FFIV	F5, Inc.	159.05
    FDS	FactSet	453.02
    FICO	Fair Isaac	996.7
    FAST	Fastenal	60.01
    FRT	Federal Realty	92.56
    FDX	FedEx	246.03
    FITB	Fifth Third Bank	25.06
    FSLR	First Solar	133.92
    FE	FirstEnergy	35.3
    FIS	FIS	52.41
    FI	Fiserv	121.51
    FLT	Fleetcor	231.21
    FMC	FMC Corporation	51.24
    F	Ford Motor Company	9.86
    FTNT	Fortinet	50.82
    FTV	Fortive	65.83
    FOXA	Fox Corporation (Class A)	30.13
    FOX	Fox Corporation (Class B)	28.08
    BEN	Franklin Templeton	22.92
    FCX	Freeport-McMoRan	33.68
    GRMN	Garmin	116.62
    IT	Gartner	411.63
    GEHC	GE HealthCare	69.52
    GEN	Gen Digital	19.28
    GNRC	Generac	103.55
    GD	General Dynamics	243.55
    GE	General Electric	115.27
    GIS	General Mills	65.28
    GM	General Motors	26.85
    GPC	Genuine Parts Company	136.16
    GILD	Gilead Sciences	75.92
    GL	Globe Life	116.64
    GPN	Global Payments	109.18
    GS	Goldman Sachs	325.51
    HAL	Halliburton	38.29
    HIG	Hartford (The)	73.97
    HAS	Hasbro	43.11
    HCA	HCA Healthcare	232.82
    PEAK	Healthpeak	15.94
    HSIC	Henry Schein	64.07
    HSY	Hershey's	191.48
    HES	Hess Corporation	141.59
    HPE	Hewlett Packard Enterprise	15.96
    HLT	Hilton Worldwide	161.8
    HOLX	Hologic	72.13
    HD	Home Depot (The)	291.59
    HON	Honeywell	186.71
    HRL	Hormel Foods	32.5
    HST	Host Hotels & Resorts	16.41
    HWM	Howmet Aerospace	49.55
    HPQ	HP Inc.	27.62
    HUBB	Hubbell Incorporated	289.52
    HUM	Humana	493.11
    HBAN	Huntington Bancshares	10.27
    HII	Huntington Ingalls Industries	229.93
    IBM	IBM	149.02
    IEX	IDEX Corporation	191.72
    IDXX	Idexx Laboratories	428.73
    ITW	Illinois Tool Works	232.49
    ILMN	Illumina	98.37
    INCY	Incyte	52.44
    IR	Ingersoll Rand	68.34
    PODD	Insulet	155.1
    INTC	Intel	38.86
    ICE	Intercontinental Exchange	109.78
    IFF	International Flavors & Fragrances	71.74
    IP	International Paper	33.09
    IPG	Interpublic Group of Companies (The)	28.98
    INTU	Intuit	528.89
    ISRG	Intuitive Surgical	277.49
    IVZ	Invesco	13.08
    INVH	Invitation Homes	31.68
    IQV	IQVIA	195.98
    IRM	Iron Mountain	59.44
    JBHT	J.B. Hunt	173.82
    JKHY	Jack Henry & Associates	147.99
    J	Jacobs Solutions	133.94
    JNJ	Johnson & Johnson	147.25
    JCI	Johnson Controls	51.25
    JPM	JPMorgan Chase	146.43
    JNPR	Juniper Networks	27.14
    K	Kellanova	51.82
    KVUE	Kenvue	19.15
    KDP	Keurig Dr Pepper	30.97
    KEY	KeyCorp	10.95
    KEYS	Keysight	124.25
    KMB	Kimberly-Clark	120.84
    KIM	Kimco Realty	17.9
    KMI	Kinder Morgan	16.44
    KLAC	KLA Corporation	534.25
    KHC	Kraft Heinz	32.89
    KR	Kroger	43.89
    LHX	L3Harris	182.17
    LH	LabCorp	204.78
    LRCX	Lam Research	685.43
    LW	Lamb Weston	94.07
    LVS	Las Vegas Sands	47.75
    LDOS	Leidos	103.55
    LEN	Lennar	122.2
    LIN	Linde plc	399.84
    LYV	Live Nation Entertainment	87.52
    LKQ	LKQ Corporation	44.83
    LMT	Lockheed Martin	444.87
    L	Loews Corporation	65.89
    LOW	Lowe's	194.6
    LULU	Lululemon Athletica	413.67
    LYB	LyondellBasell	93.82
    MTB	M&T Bank	118.35
    MRO	Marathon Oil	25.09
    MPC	Marathon Petroleum	145.13
    MKTX	MarketAxess	222.94
    MAR	Marriott International	197.6
    MMC	Marsh McLennan	200.45
    MLM	Martin Marietta Materials	453.87
    MAS	Masco	56.17
    MA	Mastercard	394.38
    MTCH	Match Group	29.7
    MKC	McCormick & Company	64.93
    MCD	McDonald's	267.79
    MCK	McKesson	469.29
    MDT	Medtronic	70.68
    MRK	Merck & Co.	101.39
    META	Meta Platforms	328.77
    MET	MetLife	60.49
    MTD	Mettler Toledo	1044.11
    MGM	MGM Resorts	38.74
    MCHP	Microchip Technology	77.56
    MU	Micron Technology	75.36
    MSFT	Microsoft	369.67
    MAA	Mid-America Apartment Communities	122.72
    MRNA	Moderna	70.05
    MHK	Mohawk Industries	80.66
    MOH	Molina Healthcare	358.08
    TAP	Molson Coors Beverage Company	58.97
    MDLZ	Mondelez International	69.12
    MPWR	Monolithic Power Systems	504.58
    MNST	Monster Beverage	55.28
    MCO	Moody's Corporation	344.57
    MS	Morgan Stanley	75.33
    MOS	Mosaic Company (The)	33.64
    MSI	Motorola Solutions	311.02
    MSCI	MSCI	514.26
    NDAQ	Nasdaq, Inc.	52.11
    NTAP	NetApp	77.14
    NFLX	Netflix	447.24
    NEM	Newmont	34.2
    NWSA	News Corp (Class A)	20.92
    NWS	News Corp (Class B)	21.78
    NEE	NextEra Energy	55.14
    NKE	Nike, Inc.	106.11
    NI	NiSource	25
    NDSN	Nordson Corporation	225.11
    NSC	Norfolk Southern Railway	196.88
    NTRS	Northern Trust	70.7
    NOC	Northrop Grumman	463.27
    NCLH	Norwegian Cruise Line Holdings	13.18
    NRG	NRG Energy	45.55
    NUE	Nucor	152.62
    NVDA	Nvidia	483.35
    NVR	NVR, Inc.	6035.29
    NXPI	NXP Semiconductors	186.67
    ORLY	O'Reilly Auto Parts	986.22
    OXY	Occidental Petroleum	60.98
    ODFL	Old Dominion	392.63
    OMC	Omnicom Group	75.74
    ON	ON Semiconductor	67.38
    OKE	ONEOK	64.36
    ORCL	Oracle Corporation	113.07
    OTIS	Otis Worldwide	82.03
    PCAR	Paccar	88.26
    PKG	Packaging Corporation of America	155.63
    PANW	Palo Alto Networks	253.51
    PARA	Paramount Global	12.1
    PH	Parker Hannifin	419.45
    PAYX	Paychex	115.43
    PAYC	Paycom	171.16
    PYPL	PayPal	54.77
    PNR	Pentair	61.4
    PEP	PepsiCo	166.92
    PFE	Pfizer	29.48
    PCG	PG&E Corporation	16.78
    PM	Philip Morris International	89.7
    PSX	Phillips 66	113.44
    PNW	Pinnacle West	70.46
    PXD	Pioneer Natural Resources	233.56
    PNC	PNC Financial Services	120.43
    POOL	Pool Corporation	330.54
    PPG	PPG Industries	128.81
    PPL	PPL Corporation	25.34
    PFG	Principal Financial Group	69.57
    PG	Procter & Gamble	151.41
    PGR	Progressive Corporation	160.39
    PLD	Prologis	104.55
    PRU	Prudential Financial	92.03
    PEG	Public Service Enterprise Group	61.61
    PTC	PTC	151.61
    PSA	Public Storage	244.78
    PHM	PulteGroup	82.37
    QRVO	Qorvo	91.66
    PWR	Quanta Services	174.07
    QCOM	Qualcomm	124.21
    DGX	Quest Diagnostics	132.82
    RL	Ralph Lauren Corporation	115.62
    RJF	Raymond James	100.5
    RTX	RTX Corporation	82.22
    O	Realty Income	50.06
    REG	Regency Centers	60.45
    REGN	Regeneron	798.94
    RF	Regions Financial Corporation	15.12
    RSG	Republic Services	157.79
    RMD	ResMed	143.6
    RVTY	Revvity	84.49
    RHI	Robert Half	76.99
    ROK	Rockwell Automation	258.43
    ROL	Rollins, Inc.	38.4
    ROP	Roper Technologies	517.15
    ROST	Ross Stores	123.33
    RCL	Royal Caribbean Group	94.91
    SPGI	S&P Global	393.97
    CRM	Salesforce	213.63
    SBAC	SBA Communications	218.99
    SLB	Schlumberger	53.3
    STX	Seagate Technology	72.42
    SEE	Sealed Air	32.34
    SRE	Sempra Energy	70.34
    NOW	ServiceNow	634.76
    SHW	Sherwin-Williams	255.75
    SPG	Simon Property Group	115.33
    SWKS	Skyworks Solutions	90.03
    SJM	J.M. Smucker Company (The)	108.74
    SNA	Snap-on	270.04
    SEDG	SolarEdge	71.14
    SO	Southern Company	68.1
    LUV	Southwest Airlines	23.16
    SWK	Stanley Black & Decker	85.07
    SBUX	Starbucks	104.33
    STT	State Street Corporation	67.6
    STLD	Steel Dynamics	109.02
    STE	Steris	199.32
    SYK	Stryker Corporation	273.62
    SYF	Synchrony Financial	29.57
    SNPS	Synopsys	518.83
    SYY	Sysco	67.34
    TMUS	T-Mobile US	147.61
    TROW	T. Rowe Price	92.62
    TTWO	Take-Two Interactive	147.88
    TPR	Tapestry, Inc.	28.12
    TRGP	Targa Resources	84.56
    TGT	Target Corporation	108.33
    TEL	TE Connectivity	126.65
    TDY	Teledyne Technologies	382.8
    TFX	Teleflex	200.05
    TER	Teradyne	88.12
    TSLA	Tesla, Inc.	214.65
    TXN	Texas Instruments	147.19
    TXT	Textron	76.12
    TMO	Thermo Fisher Scientific	448.43
    TJX	TJX Companies	91.2
    TSCO	Tractor Supply	198.54
    TT	Trane Technologies	225.48
    TDG	TransDigm Group	992.5
    TRV	Travelers Companies (The)	169.96
    TRMB	Trimble Inc.	41.85
    TFC	Truist	29.39
    TYL	Tyler Technologies	418.7
    TSN	Tyson Foods	46.95
    USB	U.S. Bank	34.2
    UDR	UDR, Inc.	32.76
    ULTA	Ulta Beauty	389.71
    UNP	Union Pacific Corporation	211.49
    UAL	United Airlines Holdings	37.99
    UPS	United Parcel Service	138.11
    URI	United Rentals	456.53
    UNH	UnitedHealth Group	541.21
    UHS	Universal Health Services	130.23
    VLO	Valero Energy	122.67
    VTR	Ventas	42.56
    VLTO	Veralto	70.55
    VRSN	Verisign	207.26
    VRSK	Verisk	237.93
    VZ	Verizon	35.71
    VRTX	Vertex Pharmaceuticals	373.65
    VFC	VF Corporation	14.9
    VTRS	Viatris	9.2
    VICI	Vici Properties	28.46
    V	Visa Inc.	245.25
    VMC	Vulcan Materials Company	211.66
    WAB	Wabtec	112.53
    WBA	Walgreens Boots Alliance	20.76
    WMT	Walmart	166.19
    WBD	Warner Bros. Discovery	10.13
    WM	Waste Management	171.77
    WAT	Waters Corporation	255.92
    WEC	WEC Energy Group	80.31
    WFC	Wells Fargo	40.89
    WELL	Welltower	85.98
    WST	West Pharmaceutical Services	341.65
    WDC	Western Digital	45
    WRK	WestRock	38.23
    WY	Weyerhaeuser	30.15
    WHR	Whirlpool Corporation	109.79
    WMB	Williams Companies	34.88
    WTW	Willis Towers Watson	240.21
    GWW	W. W. Grainger	792.25
    WYNN	Wynn Resorts	85.49
    XEL	Xcel Energy	59.2
    XYL	Xylem Inc.	98.46
    YUM	Yum! Brands	125.95
    ZBRA	Zebra Technologies	206.18
    ZBH	Zimmer Biomet	105.42
    ZION	Zions Bancorporation	32.92
    ZTS	Zoetis	169.32
    Stock Symbol	Company	Price
    MMM	3M	92.81
    AOS	A. O. Smith	72.82
    ABT	Abbott	93.97
    ABBV	AbbVie	138.59
    ACN	Accenture	319.69
    ADM	ADM	72.5
    ADBE	Adobe Inc.	597.22
    ADP	ADP	228.49
    AES	AES Corporation	15.7
    AFL	Aflac	81.48
    A	Agilent Technologies	108.47
    ABNB	Airbnb	118.15
    APD	Air Products and Chemicals	265.46
    AKAM	Akamai	110.77
    ALK	Alaska Air Group	34.26
    ALB	Albemarle Corporation	116.98
    ARE	Alexandria Real Estate Equities	95.66
    ALGN	Align Technology	192.13
    ALLE	Allegion	103.49
    LNT	Alliant Energy	48.57
    ALL	Allstate	130.32
    GOOGL	Alphabet Inc. (Class A)	132.59
    GOOG	Alphabet Inc. (Class C)	134.06
    MO	Altria	40.02
    AMZN	Amazon	143.56
    AMCR	Amcor	9.07
    AMD	AMD	118.59
    AEE	Ameren	76.27
    AAL	American Airlines Group	11.8
    AEP	American Electric Power	77.7
    AXP	American Express	154.38
    AIG	American International Group	63.82
    AMT	American Tower	183.79
    AWK	American Water Works	123.5
    AMP	Ameriprise Financial	336.36
    AME	Ametek	150.8
    AMGN	Amgen	267.31
    APH	Amphenol	86.61
    ADI	Analog Devices	172.32
    ANSS	Ansys	291.5
    AON	Aon	334.04
    APA	APA Corporation	36.92
    AAPL	Apple Inc.	186.4
    AMAT	Applied Materials	150.68
    APTV	Aptiv	75.93
    ACGL	Arch Capital Group	85.95
    ANET	Arista Networks	206.84
    AJG	Arthur J. Gallagher & Co.	248.27
    AIZ	Assurant	163.06
    T	AT&T	15.64
    ATO	Atmos Energy	111.41
    ADSK	Autodesk	210.58
    AZO	AutoZone	2702.34
    AVB	AvalonBay Communities	168.2
    AVY	Avery Dennison	180.09
    AXON	Axon Enterprise	217.94
    BKR	Baker Hughes	34.34
    BALL	Ball Corporation	48.81
    BAC	Bank of America	27.68
    BBWI	Bath & Body Works, Inc.	31.04
    BAX	Baxter International	32.82
    BDX	Becton Dickinson	234.65
    WRB	Berkley	68.15
    BRK.B	Berkshire Hathaway	350.56
    BBY	Best Buy	64.12
    BIO	Bio-Rad	304.04
    TECH	Bio-Techne	57.49
    BIIB	Biogen	224.79
    BLK	BlackRock	665
    BX	Blackstone	98.64
    BK	BNY Mellon	45.66
    BA	Boeing	196.65
    BKNG	Booking Holdings	3074.23
    BWA	BorgWarner	32.37
    BXP	Boston Properties	52.44
    BSX	Boston Scientific	51.56
    BMY	Bristol Myers Squibb	50.61
    AVGO	Broadcom Inc.	957.52
    BR	Broadridge Financial Solutions	177.12
    BRO	Brown & Brown	72.85
    BF.B	Brown–Forman	57.02
    BG	Bunge Limited	104.53
    CHRW	C.H. Robinson	79.96
    CDNS	Cadence Design Systems	261.56
    CZR	Caesars Entertainment	43.3
    CPT	Camden Property Trust	88.44
    CPB	Campbell Soup Company	40.42
    COF	Capital One	104.58
    CAH	Cardinal Health	104.12
    KMX	CarMax	63.37
    CCL	Carnival	12.76
    CARR	Carrier Global	51.5
    CTLT	Catalent	33.55
    CAT	Caterpillar Inc.	239.68
    CBOE	Cboe Global Markets	174.97
    CBRE	CBRE Group	73.49
    CDW	CDW	211.67
    CE	Celanese	118.51
    COR	Cencora	197.57
    CNC	Centene Corporation	71.87
    CNP	CenterPoint Energy	27.12
    CDAY	Ceridian	65.45
    CF	CF Industries	79.53
    CRL	Charles River Laboratories	171.99
    SCHW	Charles Schwab Corporation	54.41
    CHTR	Charter Communications	409.81
    CVX	Chevron Corporation	142.95
    CMG	Chipotle Mexican Grill	2120.58
    CB	Chubb Limited	222.44
    CHD	Church & Dwight	89.72
    CI	Cigna	293.21
    CINF	Cincinnati Financial	99.73
    CTAS	Cintas	533.48
    CSCO	Cisco	52.59
    C	Citigroup	42.08
    CFG	Citizens Financial Group	25.17
    CLX	Clorox	133.46
    CME	CME Group	217.11
    CMS	CMS Energy	55.6
    KO	Coca-Cola Company (The)	56.72
    CTSH	Cognizant	65.95
    CL	Colgate-Palmolive	75.43
    CMCSA	Comcast	41.91
    CMA	Comerica	41.35
    CAG	Conagra Brands	27.81
    COP	ConocoPhillips	115.61
    ED	Consolidated Edison	89.35
    STZ	Constellation Brands	239.32
    CEG	Constellation Energy	121.77
    COO	CooperCompanies	329.28
    CPRT	Copart	48.73
    GLW	Corning Inc.	27.68
    CTVA	Corteva	43.55
    CSGP	CoStar Group	79.65
    COST	Costco	577.12
    CTRA	Coterra	26.97
    CCI	Crown Castle	95.64
    CSX	CSX	30.7
    CMI	Cummins	219.02
    CVS	CVS Health	67.68
    DHI	D.R. Horton	122.7
    DHR	Danaher Corporation	197
    DRI	Darden Restaurants	150.1
    DVA	DaVita Inc.	82.99
    DE	John Deere	373.99
    DAL	Delta Air Lines	34.06
    XRAY	Dentsply Sirona	28.39
    DVN	Devon Energy	45.62
    DXCM	Dexcom	94.05
    FANG	Diamondback Energy	157.71
    DLR	Digital Realty	128.75
    DFS	Discover Financial	83.51
    DIS	Disney	88.27
    DG	Dollar General	117.94
    DLTR	Dollar Tree	114.08
    D	Dominion Energy	44.96
    DPZ	Domino's	378.51
    DOV	Dover Corporation	131.63
    DOW	Dow Inc.	49.48
    DTE	DTE Energy	98.57
    DUK	Duke Energy	88.27
    DD	DuPont	68.74
    EMN	Eastman Chemical Company	77.13
    ETN	Eaton Corporation	221.82
    EBAY	eBay	39.85
    ECL	Ecolab	177.9
    EIX	Edison International	63.72
    EW	Edwards Lifesciences	64.21
    EA	Electronic Arts	132.78
    ELV	Elevance Health	458.25
    LLY	Eli Lilly and Company	597.71
    EMR	Emerson Electric	86.5
    ENPH	Enphase	77.98
    ETR	Entergy	96.61
    EOG	EOG Resources	122.7
    EPAM	EPAM Systems	235.36
    EQT	EQT	39.13
    EFX	Equifax	184.91
    EQIX	Equinix	767.27
    EQR	Equity Residential	54.54
    ESS	Essex Property Trust	210.65
    EL	Estée Lauder Companies (The)	114.75
    ETSY	Etsy	63.24
    EG	Everest Re	384.68
    EVRG	Evergy	49.41
    ES	Eversource	53.8
    EXC	Exelon	39.43
    EXPE	Expedia Group	118.68
    EXPD	Expeditors International	115.35
    EXR	Extra Space Storage	119.11
    XOM	ExxonMobil	103.75
    FFIV	F5, Inc.	159.05
    FDS	FactSet	453.02
    FICO	Fair Isaac	996.7
    FAST	Fastenal	60.01
    FRT	Federal Realty	92.56
    FDX	FedEx	246.03
    FITB	Fifth Third Bank	25.06
    FSLR	First Solar	133.92
    FE	FirstEnergy	35.3
    FIS	FIS	52.41
    FI	Fiserv	121.51
    FLT	Fleetcor	231.21
    FMC	FMC Corporation	51.24
    F	Ford Motor Company	9.86
    FTNT	Fortinet	50.82
    FTV	Fortive	65.83
    FOXA	Fox Corporation (Class A)	30.13
    FOX	Fox Corporation (Class B)	28.08
    BEN	Franklin Templeton	22.92
    FCX	Freeport-McMoRan	33.68
    GRMN	Garmin	116.62
    IT	Gartner	411.63
    GEHC	GE HealthCare	69.52
    GEN	Gen Digital	19.28
    GNRC	Generac	103.55
    GD	General Dynamics	243.55
    GE	General Electric	115.27
    GIS	General Mills	65.28
    GM	General Motors	26.85
    GPC	Genuine Parts Company	136.16
    GILD	Gilead Sciences	75.92
    GL	Globe Life	116.64
    GPN	Global Payments	109.18
    GS	Goldman Sachs	325.51
    HAL	Halliburton	38.29
    HIG	Hartford (The)	73.97
    HAS	Hasbro	43.11
    HCA	HCA Healthcare	232.82
    PEAK	Healthpeak	15.94
    HSIC	Henry Schein	64.07
    HSY	Hershey's	191.48
    HES	Hess Corporation	141.59
    HPE	Hewlett Packard Enterprise	15.96
    HLT	Hilton Worldwide	161.8
    HOLX	Hologic	72.13
    HD	Home Depot (The)	291.59
    HON	Honeywell	186.71
    HRL	Hormel Foods	32.5
    HST	Host Hotels & Resorts	16.41
    HWM	Howmet Aerospace	49.55
    HPQ	HP Inc.	27.62
    HUBB	Hubbell Incorporated	289.52
    HUM	Humana	493.11
    HBAN	Huntington Bancshares	10.27
    HII	Huntington Ingalls Industries	229.93
    IBM	IBM	149.02
    IEX	IDEX Corporation	191.72
    IDXX	Idexx Laboratories	428.73
    ITW	Illinois Tool Works	232.49
    ILMN	Illumina	98.37
    INCY	Incyte	52.44
    IR	Ingersoll Rand	68.34
    PODD	Insulet	155.1
    INTC	Intel	38.86
    ICE	Intercontinental Exchange	109.78
    IFF	International Flavors & Fragrances	71.74
    IP	International Paper	33.09
    IPG	Interpublic Group of Companies (The)	28.98
    INTU	Intuit	528.89
    ISRG	Intuitive Surgical	277.49
    IVZ	Invesco	13.08
    INVH	Invitation Homes	31.68
    IQV	IQVIA	195.98
    IRM	Iron Mountain	59.44
    JBHT	J.B. Hunt	173.82
    JKHY	Jack Henry & Associates	147.99
    J	Jacobs Solutions	133.94
    JNJ	Johnson & Johnson	147.25
    JCI	Johnson Controls	51.25
    JPM	JPMorgan Chase	146.43
    JNPR	Juniper Networks	27.14
    K	Kellanova	51.82
    KVUE	Kenvue	19.15
    KDP	Keurig Dr Pepper	30.97
    KEY	KeyCorp	10.95
    KEYS	Keysight	124.25
    KMB	Kimberly-Clark	120.84
    KIM	Kimco Realty	17.9
    KMI	Kinder Morgan	16.44
    KLAC	KLA Corporation	534.25
    KHC	Kraft Heinz	32.89
    KR	Kroger	43.89
    LHX	L3Harris	182.17
    LH	LabCorp	204.78
    LRCX	Lam Research	685.43
    LW	Lamb Weston	94.07
    LVS	Las Vegas Sands	47.75
    LDOS	Leidos	103.55
    LEN	Lennar	122.2
    LIN	Linde plc	399.84
    LYV	Live Nation Entertainment	87.52
    LKQ	LKQ Corporation	44.83
    LMT	Lockheed Martin	444.87
    L	Loews Corporation	65.89
    LOW	Lowe's	194.6
    LULU	Lululemon Athletica	413.67
    LYB	LyondellBasell	93.82
    MTB	M&T Bank	118.35
    MRO	Marathon Oil	25.09
    MPC	Marathon Petroleum	145.13
    MKTX	MarketAxess	222.94
    MDLZ	Mondelez International	69.12
    MPWR	Monolithic Power Systems	504.58
    MNST	Monster Beverage	55.28
    MCO	Moody's Corporation	344.57
    MS	Morgan Stanley	75.33
    MOS	Mosaic Company (The)	33.64
    MSI	Motorola Solutions	311.02
    MSCI	MSCI	514.26
    NDAQ	Nasdaq, Inc.	52.11
    NTAP	NetApp	77.14
    NFLX	Netflix	447.24
    NEM	Newmont	34.2
    NWSA	News Corp (Class A)	20.92
    NWS	News Corp (Class B)	21.78
    NEE	NextEra Energy	55.14
    NKE	Nike, Inc.	106.11
    NI	NiSource	25
    NDSN	Nordson Corporation	225.11
    NSC	Norfolk Southern Railway	196.88
    NTRS	Northern Trust	70.7
    NOC	Northrop Grumman	463.27
    NCLH	Norwegian Cruise Line Holdings	13.18
    NRG	NRG Energy	45.55
    NUE	Nucor	152.62
    NVDA	Nvidia	483.35
    NVR	NVR, Inc.	6035.29
    NXPI	NXP Semiconductors	186.67
    ORLY	O'Reilly Auto Parts	986.22
    OXY	Occidental Petroleum	60.98
    ODFL	Old Dominion	392.63
    OMC	Omnicom Group	75.74
    ON	ON Semiconductor	67.38
    OKE	ONEOK	64.36
    ORCL	Oracle Corporation	113.07
    OTIS	Otis Worldwide	82.03
    PCAR	Paccar	88.26
    PKG	Packaging Corporation of America	155.63
    PANW	Palo Alto Networks	253.51
    PARA	Paramount Global	12.1
    PH	Parker Hannifin	419.45
    PAYX	Paychex	115.43
    PAYC	Paycom	171.16
    PYPL	PayPal	54.77
    PNR	Pentair	61.4
    PEP	PepsiCo	166.92
    PFE	Pfizer	29.48
    PCG	PG&E Corporation	16.78
    PM	Philip Morris International	89.7
    PSX	Phillips 66	113.44
    PNW	Pinnacle West	70.46
    PXD	Pioneer Natural Resources	233.56
    PNC	PNC Financial Services	120.43
    POOL	Pool Corporation	330.54
    PPG	PPG Industries	128.81
    PPL	PPL Corporation	25.34
    PFG	Principal Financial Group	69.57
    PG	Procter & Gamble	151.41
    PGR	Progressive Corporation	160.39
    PLD	Prologis	104.55
    PRU	Prudential Financial	92.03
    PEG	Public Service Enterprise Group	61.61
    PTC	PTC	151.61
    PSA	Public Storage	244.78
    PHM	PulteGroup	82.37
    QRVO	Qorvo	91.66
    PWR	Quanta Services	174.07
    QCOM	Qualcomm	124.21
    DGX	Quest Diagnostics	132.82
    RL	Ralph Lauren Corporation	115.62
    RJF	Raymond James	100.5
    RTX	RTX Corporation	82.22
    O	Realty Income	50.06
    REG	Regency Centers	60.45
    REGN	Regeneron	798.94
    RF	Regions Financial Corporation	15.12
    RSG	Republic Services	157.79
    RMD	ResMed	143.6
    RVTY	Revvity	84.49
    RHI	Robert Half	76.99
    ROK	Rockwell Automation	258.43
    ROL	Rollins, Inc.	38.4
    ROP	Roper Technologies	517.15
    ROST	Ross Stores	123.33
    RCL	Royal Caribbean Group	94.91
    SPGI	S&P Global	393.97
    CRM	Salesforce	213.63
    SBAC	SBA Communications	218.99
    SLB	Schlumberger	53.3
    STX	Seagate Technology	72.42
    SEE	Sealed Air	32.34
    SRE	Sempra Energy	70.34
    NOW	ServiceNow	634.76
    SHW	Sherwin-Williams	255.75
    SPG	Simon Property Group	115.33
    SWKS	Skyworks Solutions	90.03
    SJM	J.M. Smucker Company (The)	108.74
    SNA	Snap-on	270.04
    SEDG	SolarEdge	71.14
    SO	Southern Company	68.1
    LUV	Southwest Airlines	23.16
    SWK	Stanley Black & Decker	85.07
    SBUX	Starbucks	104.33
    STT	State Street Corporation	67.6
    STLD	Steel Dynamics	109.02
    STE	Steris	199.32
    SYK	Stryker Corporation	273.62
    SYF	Synchrony Financial	29.57
    SNPS	Synopsys	518.83
    SYY	Sysco	67.34
    TMUS	T-Mobile US	147.61
    TROW	T. Rowe Price	92.62
    TTWO	Take-Two Interactive	147.88
    TPR	Tapestry, Inc.	28.12
    TRGP	Targa Resources	84.56
    TGT	Target Corporation	108.33
    TEL	TE Connectivity	126.65
    TDY	Teledyne Technologies	382.8
    TFX	Teleflex	200.05
    TER	Teradyne	88.12
    TSLA	Tesla, Inc.	214.65
    TXN	Texas Instruments	147.19
    TXT	Textron	76.12
    TMO	Thermo Fisher Scientific	448.43
    TJX	TJX Companies	91.2
    TSCO	Tractor Supply	198.54
    TT	Trane Technologies	225.48
    TDG	TransDigm Group	992.5
    TRV	Travelers Companies (The)	169.96
    TRMB	Trimble Inc.	41.85
    TFC	Truist	29.39
    TYL	Tyler Technologies	418.7
    TSN	Tyson Foods	46.95
    USB	U.S. Bank	34.2
    UDR	UDR, Inc.	32.76
    ULTA	Ulta Beauty	389.71
    UNP	Union Pacific Corporation	211.49
    UAL	United Airlines Holdings	37.99
    UPS	United Parcel Service	138.11
    URI	United Rentals	456.53
    UNH	UnitedHealth Group	541.21
    UHS	Universal Health Services	130.23
    VLO	Valero Energy	122.67
    VTR	Ventas	42.56
    VLTO	Veralto	70.55
    VRSN	Verisign	207.26
    VRSK	Verisk	237.93
    VZ	Verizon	35.71
    VRTX	Vertex Pharmaceuticals	373.65
    VFC	VF Corporation	14.9
    VTRS	Viatris	9.2
    VICI	Vici Properties	28.46
    V	Visa Inc.	245.25
    VMC	Vulcan Materials Company	211.66
    WAB	Wabtec	112.53
    WBA	Walgreens Boots Alliance	20.76
    WMT	Walmart	166.19
    WBD	Warner Bros. Discovery	10.13
    WM	Waste Management	171.77
    WAT	Waters Corporation	255.92
    WEC	WEC Energy Group	80.31
    WFC	Wells Fargo	40.89
    WELL	Welltower	85.98
    WST	West Pharmaceutical Services	341.65
    WDC	Western Digital	45
    WRK	WestRock	38.23
    WY	Weyerhaeuser	30.15
    WHR	Whirlpool Corporation	109.79
    WMB	Williams Companies	34.88
    WTW	Willis Towers Watson	240.21
    GWW	W. W. Grainger	792.25
    WYNN	Wynn Resorts	85.49
    XEL	Xcel Energy	59.2
    XYL	Xylem Inc.	98.46
    YUM	Yum! Brands	125.95
    ZBRA	Zebra Technologies	206.18
    ZBH	Zimmer Biomet	105.42
    ZION	Zions Bancorporation	32.92
    ZTS	Zoetis	169.32
          </p>
        </section>
    </div></div></div>
    </template>
    
    <style scoped>
    body {
        margin: 0;
        padding: 0;
        background: white;
        overflow: hidden;
    }
    section {
        background: #f6ebf7;
    }
    p {
        font-size: 13px;
        line-height: 10px;
        background:  url(https://media.giphy.com/media/41x8G9RQjdKSKbO7it/giphy.webp) no-repeat;
        background-size: cover;
        background-position: center;
        background-attachment: fixed;
        -webkit-background-clip: text;
        -webkit-text-fill-color: rgba(255, 255, 255, 0) ;
        font-weight: 900;
        margin: 0;
        mix-blend-mode: darken;
 
    }
    

    
    footer {
      position: fixed;
      top: 0;
      right: 0;
      padding: 10px;
      border-bottom-left-radius: 8px;
      height: 10px;
      display: flex;
      justify-content: center;
    }
    footer a {
      color: black;
      text-decoration: none;
      font-weight: 600;
      display: flex;
        align-items: center;
    }
    
    
    </style>